window.addEventListener("load", function (event) {
  // Get the number bullets
  let rtbElements = document.getElementsByClassName("rtb-adv-block-icon");

  // For each bullet listen for click
  for (let i = 0; i < rtbElements.length; i++) {
    rtbElements[i].addEventListener("click", ShowRTBInfo, false);
    // Also listen for enter key press
    rtbElements[i].addEventListener(
      "keydown",
      function (event) {
        if (event.key === "Enter" || event.keyCode === 13) {
          ShowRTBInfo(event);
        }
      },
      false
    );
  }

  const rtb_blocks = document.querySelectorAll(".rtb-adv-block");
  const rtb_block_icons = document.querySelectorAll(".rtb-adv-block-icon");

  function ShowRTBInfo(event) {
    // Check if the event target is an img
    let targetElement = event.target;
    if (targetElement.tagName.toLowerCase() === "img") {
      // Get the span that wraps around the img
      targetElement = targetElement.closest("span");
    }

    // Get bullet number
    var bulletCount = targetElement.getAttribute("data-rtb-block-num");
    // Get matching info
    var bulletInfo = document.getElementById(bulletCount);
    rtb_blocks.forEach((block) => {
      block.classList.remove("active");
      if (block.id !== bulletInfo.id) {
        // block.style.display = "none";
        setTimeout(() => {
          // block.style.opacity = "0";
        }, 0);
      }
    });
    rtb_block_icons.forEach((icon) => {
      if (icon !== targetElement) {
        icon.classList.remove("active-bullet");
        icon.setAttribute("aria-selected", "false");
      }
    });

    targetElement.classList.add("active-bullet");
    targetElement.setAttribute("aria-selected", "true");
    // bulletInfo.style.display = "flex";
      bulletInfo.classList.add("active");
    setTimeout(() => {
      // bulletInfo.style.opacity = "1";
    }, 0);
  }
});
